import { render, staticRenderFns } from "./DetailsCard.vue?vue&type=template&id=358b74ee&scoped=true"
import script from "./DetailsCard.vue?vue&type=script&lang=js"
export * from "./DetailsCard.vue?vue&type=script&lang=js"
import style0 from "./DetailsCard.vue?vue&type=style&index=0&id=358b74ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358b74ee",
  null
  
)

export default component.exports